import { QueryResult } from '@apollo/client';
import React from 'react';
import { getFirstGraphQLErrorCode, GraphQLErrorCode, reportGraphQLError, reportNoData } from '../../data-catalog-shared';

export type RenderQueryResultRenderers<TQuery> = {
  renderLoading?: () => React.ReactNode;
  renderData: (data: TQuery) => React.ReactNode;
  renderNoData?: () => React.ReactNode;
  renderDataWithError?: (data: TQuery, errorCode: GraphQLErrorCode | null) => React.ReactNode;
  renderError?: (errorCode: GraphQLErrorCode | null) => React.ReactNode;
};

export function RenderQueryResult<TQuery, TQueryVariables>(props: {
  result: QueryResult<TQuery, TQueryVariables>,
  renderers: RenderQueryResultRenderers<TQuery>,
  log?: boolean,
}): JSX.Element {
  const { result, renderers } = props;
  if (props.log && result.data) {
    console.error('findme')
    console.error(JSON.stringify(result.data, null, 2))
  }

  return (
    <>
      {
        renderQueryResult(result, renderers)
      }
    </>
  );
}

function renderQueryResult<TQuery, TQueryVariables>(
  result: QueryResult<TQuery, TQueryVariables>,
  renderers: RenderQueryResultRenderers<TQuery>,
): React.ReactNode {
  if (result.loading) {
    return renderers.renderLoading ? renderers.renderLoading() : null;
  }
  if (result.error) {
    const errorCode = getFirstGraphQLErrorCode(result.error);
    if (result.data) {
      if (renderers.renderDataWithError) {
        return renderers.renderDataWithError(result.data, errorCode);
      } else {
        return (
          <>
            {renderers.renderData(result.data)}
            {reportGraphQLError(errorCode)}
          </>
        );
      }
    } else {
      return renderers.renderError ? renderers.renderError(errorCode) : reportGraphQLError(errorCode);
    }
  }
  if (result.data) {
    return renderers.renderData(result.data);
  }
  return renderers.renderNoData ? renderers.renderNoData() : reportNoData();
}
